import { gql } from '@apollo/client/core';
import UserPreview from '@/apollo/fragments/Notification/NotificationUserPreview.fragment';

const NotificationJobsHiringPreview = gql`
  ${UserPreview}

  fragment JobsHiringPreview on JobsHiring {
    id
    hashid
    employer {
      id
      company {
        id
        name
        logoUrl
      }
    }
    vacancy {
      id
      title
      primaryRecruiter {
        firstname
        lastname
      }
    }
  }
`;

export default NotificationJobsHiringPreview;
